//
/* eslint react/prop-types: 0 */

import React from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import defaultIcon from 'assets/illustrations/Plane-Crash.png';

const swallowClick = (event) => event.stopPropagation();

// we set this to transparent for now, don't seem to need it and don't want clutter on load
const InteractiveStateView = (props) => {
  const {
    children,
    disableTypography,
    icon,
    onClick,
    primary: primaryProp,
    primaryTypographyProps,
    secondary: secondaryProp,
    secondaryTypographyProps,
    details: detailsProp,
    detailsTypographyProps,
    useSmallerFont,
    goClick,
    goText,
    backClick,
    backText,
    widths,
    goProps,
    backProps,
  } = props;

  let primary = primaryProp || children || 'No Data';

  if (primary != null && primary.type !== Typography && !disableTypography) {
    primary = (
      <Typography variant={useSmallerFont ? 'bodyMedium' : 'titleMedium'} {...primaryTypographyProps}>
        {primary}
      </Typography>
    );
  }

  let secondary = secondaryProp;
  if (secondary != null && secondary.type !== Typography && !disableTypography) {
    secondary = (
      <Typography variant={useSmallerFont ? 'paragraphRegular' : 'bodyRegular'} {...secondaryTypographyProps}>
        {secondary}
      </Typography>
    );
  }

  let details = detailsProp;

  if (details != null && details.type !== Typography && !disableTypography) {
    details = (
      <Typography
        variant={useSmallerFont ? 'captionRegular' : 'paragraphRegular'}
        color='textSecondary'
        {...detailsTypographyProps}
      >
        {details}
      </Typography>
    );
  }

  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      sx={{ cursor: onClick ? 'pointer' : '' }}
      onClick={onClick || swallowClick}
      role='none'
      style={props.style}
      direction='row'
      gap={2}
    >
      <img alt='nothing to report' src={icon || defaultIcon} style={{ maxHeight: 219, maxWidth: 203, width: '23%' }} />
      <Stack gap={1}>
        <Stack gap={0.5}>
          {primary}
          {secondary}
        </Stack>
        {details}
        {(goText || backText) && (
          <Stack direction='row' gap={1}>
            {goText && (
              <Button
                variant='contained'
                size={useSmallerFont ? 'small' : 'medium'}
                style={{ width: widths || '' }}
                onClick={goClick}
                {...goProps}
              >
                {goText}
              </Button>
            )}
            {backText && (
              <Button variant='outlined' onClick={backClick} style={{ width: widths || '' }} {...backProps}>
                {backText}
              </Button>
            )}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default InteractiveStateView;
